import { useCallback } from "react";
import { toTitleCase as titleCaseUtil } from "../utils/stringUtils";

/**
 * Hook that returns a stable toTitleCase function
 * This maintains backward compatibility with existing components
 * while ensuring the function reference doesn't change between renders
 */
export const useTitleCase = () => useCallback((str: string) => titleCaseUtil(str), []);
